// extracted by mini-css-extract-plugin
var _1 = "references-module_active__naG44B";
var _2 = "references-module_address__fb_vU0";
var _3 = "references-module_btn__OBF2hr";
var _4 = "references-module_btnContainer__ZQrMMw";
var _5 = "references-module_button_bright__rRn3AM";
var _6 = "references-module_copyCountContainer__iGt04R";
var _7 = "references-module_counter__M8bYv9";
var _8 = "references-module_deliveryPlace__kwniHA";
var _9 = "references-module_head_title__n_36Vb";
var _a = "references-module_input__oJXaqF";
var _b = "references-module_menuItem__bvkDwT";
var _c = "references-module_note__MX9Uow";
var _d = "references-module_select__NSXq1O";
var _e = "references-module_title__jcUONc";
export { _1 as "active", _2 as "address", _3 as "btn", _4 as "btnContainer", _5 as "button_bright", _6 as "copyCountContainer", _7 as "counter", _8 as "deliveryPlace", _9 as "head_title", _a as "input", _b as "menuItem", _c as "note", _d as "select", _e as "title" }
